import { Link } from "react-router-dom";
import styled from "styled-components";

const InvisibleLink = styled(Link)`
    all: unset;
    cursor: pointer;
`

export default InvisibleLink;